import { render } from "./Breeding.vue?vue&type=template&id=116ef8a0&scoped=true"
import script from "./Breeding.vue?vue&type=script&lang=js"
export * from "./Breeding.vue?vue&type=script&lang=js"

import "./Breeding.vue?vue&type=style&index=0&id=116ef8a0&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116ef8a0"]])

export default __exports__